import { extendTheme } from "@chakra-ui/react";

import {
  Spinner, // ok
  Heading, // ok
  Container, // ok
  Text, // ok
  Skeleton, // ok
  Radio, // ok
  Checkbox,
  FormLabel,
  Input,
  Link,
  PinInput,
  Button,
} from "./components";
import {
  borderRadius,
  colors,
  fonts,
  sizes,
  space,
} from "./base";

/**
 * Main theme of the application.
 */
export const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        fontWeight: "normal",
      },
    },
  },
  semanticTokens: {
    colors: {
      error: "red.500",
      secondary: "gray.500",
      success: "green.400",
      primary: "dark.500",
    },
  },
  components: {
    Spinner, // ok
    Heading, // ok
    Container, // ok
    Text, // ok
    Skeleton, // ok
    Radio, // ok
    FormLabel,
    Input,
    PinInput,
    Link,
    Checkbox,
    Button,
  },
  ...colors,
  ...fonts,
  ...borderRadius,
  ...space,
  ...sizes,
});
